import {Loader} from '@hconnect/uikit/src/lib2'
import {useTranslation} from 'react-i18next'

import {useAreaTypeId} from '../../hooks/upmEntityConfig/useAreaTypeId'
import {useDepartmentDetails} from '../../hooks/upmEntityConfig/useDepartmentDetails'
import {useDepartmentTypes} from '../../hooks/upmEntityConfig/useDepartmentTypes'
import {useOperationalStatuses} from '../../hooks/upmEntityConfig/useOperationalStatuses'
import {ItemDetailsLayout} from '../../plant-setup-item-layout'
import {useSelectedItem} from '../../providers'

import {DepartmenTypeForm} from './DepartmenTypeForm'

export const Admin = () => {
  const {selectedItem} = useSelectedItem()
  const areaCode = selectedItem?.entityCodesPath?.split('_')?.[0]

  const {data: areaTypeId} = useAreaTypeId(areaCode)

  const {
    data: departmentTypes,
    isLoading: isLoadingTypes,
    isFetching: isFetchingTypes
  } = useDepartmentTypes(areaTypeId)
  const {
    data: department,
    isLoading: isLoadingDepartment,
    isFetching: isFetchingDepartment
  } = useDepartmentDetails(selectedItem?.upmId)
  const {
    data: operationalStatuses,
    isLoading: isLoadingOperationalStatuses,
    isFetching: isFetchingOperationalStatuses
  } = useOperationalStatuses()

  const isLoading =
    isLoadingDepartment ||
    isLoadingTypes ||
    isFetchingDepartment ||
    isFetchingTypes ||
    isLoadingOperationalStatuses ||
    isFetchingOperationalStatuses

  const {t} = useTranslation()

  if (isLoading) {
    return (
      <ItemDetailsLayout>
        <Loader />
      </ItemDetailsLayout>
    )
  }

  if (
    !department ||
    !departmentTypes ||
    departmentTypes.length === 0 ||
    !operationalStatuses ||
    operationalStatuses.length === 0
  ) {
    return <ItemDetailsLayout>{t('common.noData')}</ItemDetailsLayout>
  }

  return (
    <DepartmenTypeForm
      department={department}
      departmentTypes={departmentTypes}
      operationalStatuses={operationalStatuses}
    />
  )
}
